import { PORTAL_ROUTE_PREFIX } from '../../routes/common/constants';

export const HUB_ROUTES = {
	USER_PROFILE: {
		path: '/user/profile',
		name: 'hubs-user-profile',
	},
	REQUESTS_LIST: {
		path: '/user/requests',
		name: 'requests-list',
	},
	CSM_REQUESTS_LIST: {
		path: '/user/requests',
		name: 'csm-requests-list',
	},
	CSM_CONTACT_US: {
		path: '/contact-us/:requestId([0-9]+|[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12})?',
		name: 'contact-us',
	},
	NOT_FOUND: {
		path: '(.*)',
		name: 'hubs-not-found-error-page',
	},
	CSM_FOLDER: {
		path: '/folder/:folderId',
		name: 'csm-folder',
	},
	CSM_REQUEST_DETAILS: {
		path: '/user/requests/:requestKey',
		name: 'csm-request-details',
	},
	VIEW_PORTAL_ARTICLE: {
		path: `${PORTAL_ROUTE_PREFIX}/article/:articleId`,
		name: 'hubs-view-portal-kb-article',
	},
	PORTAL_ACCESS_FORBIDDEN: {
		path: '/user/forbidden',
		name: 'hubs-portal-access-forbidden',
	},
	VIEW_ARTICLE: {
		path: '/article/:articleId',
		name: 'hubs-view-kb-article',
	},
	VIEW_KB_ARTICLE: {
		path: '/kb/view/:pageId',
		name: 'hubs-view-kb-article',
	},
	VIEW_CROSS_SITE_PORTAL_ARTICLE: {
		path: `${PORTAL_ROUTE_PREFIX}/cloudId/:cloudId/article/:articleId`,
		name: 'hubs-view-portal-cross-site-kb-article',
	},
	VIEW_CROSS_SITE_ARTICLE: {
		path: '/cloudId/:cloudId/article/:articleId',
		name: 'hubs-view-kb-cross-site-article',
	},
	LOGIN: {
		path: '/user/login',
		name: 'hubs-login',
	},
	PORTAL_LOGIN: {
		path: `${PORTAL_ROUTE_PREFIX}/user/login`,
		name: 'hubs-portal-login',
	},
	SIGNUP: {
		path: '/user/signup',
		name: 'hubs-user-signup',
	},
	PORTAL_SIGNUP: {
		path: `${PORTAL_ROUTE_PREFIX}/user/signup`,
		name: 'hubs-portal-signup',
	},
	COMPLETE_SIGNUP: {
		path: '/user/complete-signup',
		name: 'hubs-user-complete-signup',
	},
	PORTAL_COMPLETE_SIGNUP: {
		path: `${PORTAL_ROUTE_PREFIX}/user/complete-signup`,
		name: 'hubs-portal-complete-signup',
	},
	RESET_PASSWORD: {
		path: '/user/resetpassword',
		name: 'hubs-user-reset-password',
	},
	PORTAL_RESET_PASSWORD: {
		path: `${PORTAL_ROUTE_PREFIX}/user/resetpassword`,
		name: 'hubs-portal-reset-password',
	},
	CHECK_EMAIL: {
		path: '/user/check-email',
		name: 'hubs-user-checkmail',
	},
	PORTAL_INVITED_SIGNUP: {
		path: `${PORTAL_ROUTE_PREFIX}/user/visitportal`,
		name: 'hubs-portal-invited-signup',
	},
	UNSUBSCRIBE: {
		path: `${PORTAL_ROUTE_PREFIX}/:requestKey/unsubscribe`,
		name: 'hubs-unsubscribe',
	},
	REQUEST_FEEDBACK: {
		path: `${PORTAL_ROUTE_PREFIX}/:requestKey/feedback`,
		name: 'jsm-hubs-request-feedback',
	},
	REQUEST_CREATE: {
		path: `/portal/:portalId/create/:requestTypeId`,
		name: 'jsm-hubs-request-create',
	},
	ANONYMOUS_REQUEST_SUCCESS: {
		path: `/portal/:portalId/create/:requestTypeId/confirm`,
		name: 'jsm-hubs-anonymous-request-success',
	},
	JSM_REQUEST_DETAILS: {
		path: `/portal/:portalId/:requestKey`,
		name: 'jsm-hubs-request-details',
	},
	JSM_REQUESTS_LIST: {
		path: `/user/requests`,
		name: 'jsm-hubs-requests-list',
	},
	JSM_APPROVALS: {
		path: `/user/approvals`,
		name: 'jsm-hubs-approvals',
	},
	JSM_REQUEST_APPROVAL: {
		path: `/portal/:portalId/:requestKey/approval/:approvalId/:decision`,
		name: 'jsm-hubs-request-approval',
	},
	HUB_ARTICLES: {
		name: 'view-kb-article',
		path: `/article/:articleId`,
	},
	HUB_KB_PAGE: {
		name: 'view-kb-page',
		path: `/kb/view/:pageId`,
	},
	HUB_CROSS_SITE_ARTICLE: {
		name: 'view-kb-cross-site-article',
		path: `/cloudId/:cloudId/article/:articleId`,
	},
	SURVEY: {
		name: 'survey',
		path: `/portal/:portalId/survey/:surveyId`,
	},
};
